<div class="profile-container">
    <div class="">
      <div class="profile-content">
        <!-- <div class="personal-details">
          <h4 class="personal-details-title">Banner Zone List</h4>
          <table class="table table-striped">
            <thead>
              <tr>
                <th style="width: 10%;">Name</th>
                <th style="width: 10%;">Type</th>
                <th style="width: 10%;">Text</th>                
                <th style="width: 10%;">Location</th>
                <th style="width: 35%;">Description</th>
                <th style="width: 10%;text-align: center">Image</th>
                <th style="width: 5%;">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let banner of bannerZoneList | paginate : {
                itemsPerPage: tableSize,
                currentPage: page,
                totalItems: count};let i = index">
                <th>{{banner.name}}</th>
                <th>{{banner.type}}</th>
                <th>{{banner.text}}</th>
                <th>{{banner.location}}</th>
                
                <th>{{banner.description}}</th>
                <th class="list-image">
                    <img src="{{banner.image}}" alt="" srcset="">
                </th>
                <th>
                  <i class="bi bi-eye-fill" (click)="getBannerZoneById(banner.bannerZoneId)" data-toggle="modal" data-target="#exampleModalView" ></i>
                </th>
              </tr>
            </tbody>
          </table>
          <div class="pagination-block" *ngIf="bannerZoneList.length != 0">
            <pagination-controls
              previousLabel="Prev"
              nextLabel="Next"
              (pageChange)="onTableDataChange($event)"
            >
            </pagination-controls>
          </div>
        </div> -->
  
  
        <div class="personal-details">
          
          <div class="header-block">
            <div class="header-title">
              <app-breadcrumb></app-breadcrumb>
            </div>
            <div class="add-block">
                <div class="filter-icon">
                    <i class="bi bi-funnel" (click)="toggleFilter()"></i>
                    <!-- <i class="bi bi-arrow-clockwise" (click)="refreshTickets()"></i> -->
                  </div>
            </div>
          </div>
  
        <div style="display: flex;">
            <div class="dataList-content" [ngClass]="{'dataList-content-width': showFilter}">
                <table class="table table-striped">
                    <thead>
                      <tr>
                        <th style="width: 30%;">File Or Folder Name</th>
                        <th style="width: 30%;">Path</th>
                        <th style="width: 30%;">Description</th>
                        <th style="width: 10%;text-align: center;padding: 0;" class="">Action</th>
                      </tr>
                    </thead>
                  </table>
                  <div *ngIf="!isLoading">
                    <div class="data-view" *ngFor="let list of tagSearchForClientDocsData | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: pageNumber,
                      totalItems: totalRecords};let i = index">
          
                      <p style="width: 30%;">{{list.fileOrFolderName}}</p>
                      <p style="width: 30%;">{{list.path}}</p>
                      <p style="width: 30%;">{{list.description}}</p>
                      <p class="action-buttons" style="width: 10%;padding-left: 25px;">
                        <!-- <i class="bi bi-eye-fill" (click)="getClientDocByClientDocId(list.clientDocsId)" data-toggle="modal" data-target="#exampleModalView" ></i> -->
                        <i class="bi bi-eye-fill" (click)="getFolderHierarchyByParentFolderId(list.path,list.clientDocsId)" data-toggle="modal" data-target="#exampleModalView" ></i>

                    </p>
                    </div>
                  </div>

                  <div class="loader"  *ngIf="!isLoading && tagSearchForClientDocsData.length == 0">
                    <div class="no-data">
                      <img src="assets/no-data-6.png" alt="">
                      <p>no data found</p>
                    </div>
                  </div>

                  <div class="loader" *ngIf="isLoading">
                    <div class="spinner"></div>
                  </div>
            </div>

            <div class="filter-block" *ngIf="showFilter">
                <div class="filters">
                  <div class="filter-title">
                    <p>Filters</p>
                    <div class="filter-apply-button">
                      <button (click)="applyFilter()">Apply</button>
                    </div> 
                  </div>
                  <div class="single-filter form-group">
                    <label ><span><input name="filter" (click)="filterClicked('tagNameSearchChecked')" type="radio"></span>Tag Name </label>
                    <input type="text" [(ngModel)]="tagNameSearch" class="form-control">
                  </div>

                  <div class="single-filter form-group">
                    <label ><span><input name="filter" (click)="filterClicked('metaDataNameSearchChecked')" type="radio"></span>Meta Data Name </label>
                    <input type="text" [(ngModel)]="metaDataNameSearch" class="form-control">
                  </div>

                  <div class="single-filter form-group">
                    <label ><span><input name="filter" (click)="filterClicked('createdDateSearchChecked')" type="radio"></span>Created Date </label>
                    <input type="date" [(ngModel)]="createdDateSearch" class="form-control">
                  </div>
           

                  
    
                </div>
              </div>

        </div>





  
  

  
          <!-- <div class="loader"  *ngIf="!isLoading && bannerZoneList.length == 0">
            <div class="no-data">
              <img src="assets/no-data-6.png" alt="">
              <p>no data found</p>
            </div>
          </div> -->
  
          
        </div>
      </div>
    </div>
  </div>